(function () {
  function setItemState(item, isOpen) {
    var button = item.querySelector('[data-faq-item-toggle]');
    var panel = item.querySelector('[data-faq-panel]');

    item.classList.toggle('active', isOpen);

    if (button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (!panel) {
      return;
    }

    if (isOpen) {
      panel.style.maxHeight = getPanelHeight(panel) + 'px';
    } else {
      panel.style.maxHeight = '0px';
    }
  }

  function getPanelHeight(panel) {
    var content = panel.querySelector('.item_bot_text');
    var contentHeight = content ? content.scrollHeight : 0;
    return Math.ceil(Math.max(panel.scrollHeight, contentHeight)) + 28;
  }

  function updateOpenPanelHeights(section) {
    section.querySelectorAll('[data-faq-row].active').forEach(function (item) {
      setItemState(item, true);
    });
  }

  function normalizeText(value) {
    return (value || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function filterRows(section) {
    var input = section.querySelector('[data-faq-search-input]');
    var groups = Array.prototype.slice.call(section.querySelectorAll('[data-faq-group]'));
    var rows = Array.prototype.slice.call(section.querySelectorAll('[data-faq-row]'));
    var empty = section.querySelector('[data-faq-search-empty]');
    var query = normalizeText(input ? input.value : '');
    var visibleCount = 0;

    rows.forEach(function (row) {
      var text = normalizeText(row.textContent);
      var isVisible = !query || text.indexOf(query) !== -1;

      row.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    groups.forEach(function (group) {
      var hasVisibleRow = Array.prototype.slice.call(group.querySelectorAll('[data-faq-row]')).some(function (row) {
        return !row.hidden;
      });
      var groupToggle = group.querySelector('[data-faq-group-toggle]');

      group.hidden = !hasVisibleRow;

      if (query && hasVisibleRow) {
        group.classList.remove('is-collapsed');

        if (groupToggle) {
          groupToggle.setAttribute('aria-expanded', 'true');
        }
      }
    });

    if (empty) {
      empty.hidden = visibleCount > 0;
    }

    updateOpenPanelHeights(section);
  }

  function initFaqSearchToggle(section) {
    if (!section || section.dataset.faqSearchToggleReady === 'true') {
      return;
    }

    section.dataset.faqSearchToggleReady = 'true';

    section.querySelectorAll('[data-faq-row]').forEach(function (item) {
      var button = item.querySelector('[data-faq-item-toggle]');
      var isOpen = item.classList.contains('active');

      setItemState(item, isOpen);

      if (!button) {
        return;
      }

      button.addEventListener('click', function () {
        var shouldOpen = !item.classList.contains('active');
        var groupPanel = item.closest('[data-faq-group-panel]');

        if (groupPanel && shouldOpen) {
          groupPanel.querySelectorAll('[data-faq-row].active').forEach(function (openItem) {
            if (openItem !== item) {
              setItemState(openItem, false);
            }
          });
        }

        setItemState(item, shouldOpen);
      });
    });

    section.querySelectorAll('[data-faq-group-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('[data-faq-group]');
        var isCollapsed = group && group.classList.toggle('is-collapsed');

        button.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      });
    });

    var input = section.querySelector('[data-faq-search-input]');
    var searchButton = section.querySelector('[data-faq-search-submit]');

    if (input) {
      input.addEventListener('input', function () {
        filterRows(section);
      });
    }

    if (searchButton) {
      searchButton.addEventListener('click', function () {
        filterRows(section);

        if (input) {
          input.focus();
        }
      });
    }
  }

  function initAllFaqSearchToggles(scope) {
    (scope || document).querySelectorAll('[data-faq-search-toggle]').forEach(initFaqSearchToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllFaqSearchToggles(document);
    });
  } else {
    initAllFaqSearchToggles(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllFaqSearchToggles(event.target);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-faq-search-toggle]').forEach(updateOpenPanelHeights);
  });

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-faq-search-toggle]').forEach(updateOpenPanelHeights);
  });
})();
